import React from 'react';
import './Capabilities.css';

const Capabilities = () => {
    const caps = [
        { title: 'Advanced CNC & VMC Machines', icon: 'https://sakthivel.ascentbw.com/Files/Home/Icon1.png' },
        { title: 'Close Tolerance Machining', icon: 'https://sakthivel.ascentbw.com/Files/Home/Icon2.png' },
        { title: <>On-Time <br /> Delivery</>, icon: 'https://sakthivel.ascentbw.com/Files/Home/Icon3.png' },
        { title: 'Quality-Focused Operations', icon: 'https://sakthivel.ascentbw.com/Files/Home/Icon4.png' },
        { title: 'Industrial Client Support', icon: 'https://sakthivel.ascentbw.com/Files/Home/Icon5.png' },
    ];

    return (
        <section className="capabilities">
            <div className="cap-bg-overlay"></div>
            <div className="container cap-container">
                <h2 className="cap-main-title">Precision. Reliability. <br /> Performance.</h2>

                <div className="cap-grid">
                    {caps.map((cap, index) => (
                        <div key={index} className="cap-card">
                            <div className="cap-icon">
                                <img src={cap.icon} alt={cap.title} />
                            </div>
                            <p>{cap.title}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Capabilities;
